module.exports = __webpack_public_path__ + "assets/img/5.4e065190.png";